import ControlViewModel from '@/ViewModels/ControlViewModel';
import TextBoxViewModel from '@/ViewModels/Controls/TextBoxViewModel';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import HiddenViewModel from '@/ViewModels/Controls/HiddenViewModel';
import ComponentManager from '@/Management/ComponentManager';
/**
 * Das ViewModel für die AssociationBox
 */
export default class AssociationBoxViewModel extends ControlViewModel {

    /**
     * Das ViewModel für die TextBox
     */
    public textBox: TextBoxViewModel;

    /**
     * Das ViewModel für das Hidden
     */
    public hidden: HiddenViewModel;

    /**
     * Das ViewModel für den Link zum Erzeugen eines neuen Objekts
     */
    public linkCreate: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Selektieren eines bestehenden Objekts
     */
    public linkSelect: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Editieren des assoziierten Objekts
     */
    public linkEdit: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Lösen der Association
     */
    public linkDisconnect: LinkViewModel;

    /**
     * Das ViewModel für den Link zum Löschen des assoziierten Objekts
     */
    public linkDelete: LinkViewModel;

    /**
     * Die Funktion zum Lösen der Association
     */
    public disconnectItem: Function;

    /**
     * @param params {object} params - Ein Objekt mit Optionen für das Control
     */
    constructor(params: any) {
        super(params);
        this.textBox = this.paramOrDefault(params.textBox, null);
        this.hidden = this.paramOrDefault(params.hidden, null);
        this.linkCreate = this.paramOrDefault(params.linkCreate, null);
        this.linkSelect = this.paramOrDefault(params.linkSelect, null);
        this.linkEdit = this.paramOrDefault(params.linkEdit, null);
        this.linkDisconnect = this.paramOrDefault(params.linkDisconnect, null);
        this.linkDelete = this.paramOrDefault(params.linkDelete, null);
        this.disconnectItem = this.handlerOrDefault(params.disconnectItem);
    }
}

ComponentManager.setViewModel('AssociationBoxViewModel', AssociationBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');